import { checkIdentifier, checkName } from "@/constant/validator";
import { memberIdentifierCheck } from "@/api/console/model/model-definition";
import { validityProductName, customJsonFile, standardJsonFile } from "@/api/console/model/product";

const defaultFilterFiled = {
  sort: "update_time",
  orderBy: "DESC",
  released: "",
  industryIds: [],
  categoryIds: [],
  verCreateIds: [], // 录入人
  releasedIds: [] // 发布人
};
// 自定义产品
const columns_custom = [
  {
    title: "序号",
    dataIndex: "sn",
    key: "sn",
    width: 70,
    fixed: "left"
  },
  {
    title: "编码",
    dataIndex: "identifier",
    key: "identifier",
    // sorter: true,
    ellipsis: true
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "描述",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
  {
    title: "分类",
    dataIndex: "categoryVos",
    key: "categoryVos",
    ellipsis: true
  },
  {
    title: "行业",
    dataIndex: "industryVos",
    key: "industryVos",
    ellipsis: true
  },
  {
    title: "发布状态",
    dataIndex: "released",
    key: "released",
    ellipsis: true,
    filters: [
      {
        text: "已发布",
        value: true
      },
      {
        text: "未发布",
        value: false
      }
    ]
  },
  {
    title: "录入人",
    dataIndex: "productCreateUser",
    key: "productCreateUser"
  },
  {
    title: "发布人",
    dataIndex: "releasedUser",
    key: "releasedUser"
  },
  {
    title: "最后更新",
    dataIndex: "updateTime",
    key: "updateTime",
    // ellipsis: true
    width: 200
  },
  {
    title: "操作",
    dataIndex: "operate",
    key: "operate",
    fixed: "right",
    width: 200
  }
];
// 标准产品
const columns_standard = [
  {
    title: "序号",
    dataIndex: "sn",
    key: "sn",
    width: 70,
    fixed: "left"
  },
  {
    title: "编码",
    dataIndex: "identifier",
    key: "identifier",
    // sorter: true,
    ellipsis: true
  },
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "描述",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
  {
    title: "分类",
    dataIndex: "categoryVos",
    key: "categoryVos",
    ellipsis: true
  },
  {
    title: "版本",
    dataIndex: "version",
    key: "version"
  },
  {
    title: "最后更新",
    dataIndex: "updateTime",
    key: "updateTime",
    // ellipsis: true
    width: 200
  },
  {
    title: "操作",
    dataIndex: "operate",
    key: "operate",
    fixed: "right",
    width: 200
  }
];

// 校验规则

let productId = null;
export const changeId = (id) => {
  productId = id;
};

const rules = {
  identifier: [
    {
      required: true,
      validator: (rules, value) =>
        checkIdentifier(rules, "c_" + value, memberIdentifierCheck, productId),
      trigger: "blur"
    }
  ],
  name: [
    {
      required: true,
      validator: (rules, value) => checkName(rules, value, validityProductName, productId),
      trigger: "blur"
    }
  ],
  description: [
    {
      required: true,
      message: "请输入描述",
      trigger: "blur"
    }
  ],
  categoryId: [
    {
      required: true,
      message: "请选择分类",
      trigger: "change"
    }
  ],
  industryIds: [
    {
      required: true,
      message: "请选择行业",
      trigger: "change",
      type: "array"
    }
  ]
};

const fomatTxt = (arr, reverse = false) => {
  if (!arr?.length) return "";
  let str = "";
  if (reverse) {
    arr.forEach((item) => {
      str += item.nodeName + "/";
    });
    str = str.substr(0, str.length - 1);
  } else {
    arr.forEach((item) => {
      str += item.name + " | ";
    });
    str = str.substr(0, str.length - 2);
  }
  return str;
};

// getChild
const getChild = (arr, result = [], pname = "") => {
  const list = result;
  arr.map((item) => {
    if (item.children?.length) {
      pname = item.title;
      return getChild(item.children, list, pname);
    } else {
      if (pname) item.title = pname + "/" + item.title;
      list.push(item);
    }
  });
  return list;
};
// 设置筛选列表
const setFilters = (res, text, value, dataIndex) => {
  const list = [];
  res.map((item) => {
    list.push({ text: item[text], value: item[value] });
  });
  const row1 = columns_custom.find((item) => item.dataIndex === dataIndex);
  if (row1) row1.filters = list;
};
// 获取产品完整json
const getJson = async (record, recordId) => {
  const { namespace, id, productVerId } = record;
  const request =
    namespace === "custom"
      ? customJsonFile({ productId: recordId || id })
      : standardJsonFile({ productVerIds: [recordId || productVerId] });
  const res = await request;
  let result = null;
  if (res.success) {
    if (namespace === "custom") result = res.data;
    else result = res.data?.[0];

    return result;
  }
};

const menuList = [
  { name: "自定义产品", key: "custom" },
  { name: "标准产品", key: "standard" }
];

export {
  columns_standard,
  columns_custom,
  rules,
  fomatTxt,
  getChild,
  setFilters,
  getJson,
  defaultFilterFiled,
  menuList
};
